import * as getBogSettings from './reducers/get-bog-settings';
import * as putBogSettings from './reducers/put-bog-settings';
import * as getBetLimitSettings from './reducers/get-bet-limit-settings';
import * as putBetLimitSettings from './reducers/put-bet-limit-settings';

import * as getWidgetSettings from './reducers/get-widget-settings';
import * as putWidgetSettings from './reducers/put-widget-settings';

import * as getCashOutSettings from './reducers/get-cashout-settings';
import * as putCashOutSettings from './reducers/put-cashout-settings';

// eslint-disable-next-line import/no-default-export
export default {
    SYSTEM_SETTINGS_GET_BOG_SETTINGS_REQUEST: getBogSettings.request,
    SYSTEM_SETTINGS_PUT_BOG_SETTINGS_REQUEST: putBogSettings.request,
    SYSTEM_SETTINGS_GET_BET_LIMIT_REQUEST: getBetLimitSettings.request,
    SYSTEM_SETTINGS_PUT_BET_LIMIT_REQUEST: putBetLimitSettings.request,

    SYSTEM_SETTINGS_GET_WIDGET_SETTINGS_REQUEST: getWidgetSettings.request,
    SYSTEM_SETTINGS_PUT_WIDGET_SETTINGS_REQUEST: putWidgetSettings.request,

    SYSTEM_SETTINGS_GET_CASHOUT_SETTINGS_REQUEST: getCashOutSettings.request,
    SYSTEM_SETTINGS_PUT_CASHOUT_SETTINGS_REQUEST: putCashOutSettings.request,
};
